module.exports = __webpack_public_path__ + "img/23.01ea55e8.png";